import type React from 'react';

import {
  BodyText,
  ConfirmationModal,
  type ConfirmationModalProps,
  ModalType,
} from '@cobliteam/base-components';

export interface DeleteChecklistDialogProps
  extends Pick<
    ConfirmationModalProps,
    'open' | 'loading' | 'onCancel' | 'onConfirm'
  > {
  checklistName: string;
}

export const DeleteChecklistDialog: React.FC<DeleteChecklistDialogProps> = ({
  open,
  loading,
  checklistName,
  onCancel,
  onConfirm,
}) => {
  return (
    <ConfirmationModal
      open={open}
      loading={loading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      headerText='Excluir checklist'
      buttonText='Excluir'
      type={ModalType.DELETE}
    >
      <BodyText>
        Ao excluir, a checklist não estará mais disponível para ser preenchida
        por agentes de campo. Essa ação não poderá ser desfeita.
        <br />
        <br />
        Tem certeza que deseja excluir a checklist
        <strong>{checklistName}</strong>?
      </BodyText>
    </ConfirmationModal>
  );
};

export default DeleteChecklistDialog;
